<template>
  <div>
    <van-nav-bar
      title="活动专区"
      left-text="返回"
      left-arrow
      @click-left="$router.push('/')"
    />
    <div>
      <router-link
        v-for="(item, index) in activeList"
        :key="index"
        :to="{
          path: '/activity/activity_detail',
          query: { activityid: item.id },
        }"
      >
        <van-image width="100%" :src="item.title" />
      </router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: "Activity",
  data() {
    return {
      activeList: [],
    };
  },
  methods: {
    getActivity() {
      let that = this;
      const toast = that.$ShowCommonLoading();
      that
        .$http({
          url: "/",
          method: "POST",
          data: {
            nozzle: "active_activitylist",
            type: 1,
          },
        })
        .then((ret) => {
          let resData = ret.data;
          if (resData.code === 1) {
            toast.clear();
            that.activeList = resData.data;
          } else {
            toast.clear();
            that.$toast.fail(resData.msg);
          }
        })
        .catch(() => {
          toast.clear();
          that.$toast.fail(that.$NoNetworkErrorMsg);
        });
    },
  },
  mounted: function () {
    let that = this;
    this.getActivity();
  },
};
</script>

<style scoped>
.navStyles {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 1000;
}
</style>



// WEBPACK FOOTER //
// src/components/Activity.vue